<template>
  <modal v-if="visible">
    <template slot="modal-header">
      <h2 class="mt-3">Activity Log</h2>
    </template>
    <template slot="modal-body">
      <div class="px-3">
        <vue-good-table
          :columns="columns"
          :rows="data"
          :sort-options="{
            enabled: false,
          }"
        ></vue-good-table>
      </div>
    </template>
    <template slot="modal-footer">
      <div class="mb-3">
        <app-primary-button
          label="Close"
          @click.native="closeModal"
        ></app-primary-button>
      </div>
    </template>
  </modal>
</template>
<script>
import {VueGoodTable} from 'vue-good-table';
import AppPrimaryButton from '../../AppComponents/Forms/AppPrimaryButton.vue';
import Modal from '../../../helpers/Modal.vue';
import {format} from 'date-fns';
import UtcToTimezone from '../../../helpers/UtcToTimezone';

export default {
  props: ['visible', 'data'],
  components: {
    VueGoodTable,
    AppPrimaryButton,
    Modal,
  },
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
  },
  computed: {
    columns() {
      return [
        {
          field: 'action',
          label: 'Description',
        },
        {
          field: (props) =>
            format(
              UtcToTimezone(props.createdAt, 'yyyy-MM-dd HH:mm:ss'),
              'DD MMM YYYY h:mm A'
            ),
          label: 'Timestamp',
          type: 'text',
        },
      ];
    },
  },
};
</script>
